import { createContext, useContext, useState } from 'react';
import axios from 'axios';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  // Combined pending count for the sidebar "Requests" badge:
  // pending client requests + pending non-card wallet deposits.
  const [pendingRequestCount, setPendingRequestCount] = useState(0);

  const refreshUnreadCount = async () => {
    try {
      const res = await axios.get('/api/notifications/unread-count');
      setUnreadCount(res.data.count);
    } catch (err) {
      console.error('Failed to refresh notification count:', err);
    }
  };

  const refreshPendingRequestCount = async () => {
    try {
      const res = await axios.get('/api/client-change-requests/pending-count');
      setPendingRequestCount(res.data.count);
    } catch (err) {
      console.error('Failed to refresh pending request count:', err);
    }
  };

  return (
    <NotificationContext.Provider
      value={{ unreadCount, refreshUnreadCount, pendingRequestCount, refreshPendingRequestCount }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
